import { render, staticRenderFns } from "./AbandonedVisit.vue?vue&type=template&id=2bbe6817&"
import script from "./AbandonedVisit.vue?vue&type=script&lang=js&"
export * from "./AbandonedVisit.vue?vue&type=script&lang=js&"
import style0 from "./AbandonedVisit.vue?vue&type=style&index=0&id=2bbe6817&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MiniCartSlider: require('/home/jeanmarcphilippe/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/components/MiniCartSlider.vue').default})
